import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { PlatformEnvDataProviderSymbol, WixCodeSdkHandlersProviderSym } from '@wix/thunderbolt-symbols'
import { ClientSdkHandlersProvider } from './clientSdkHandlersProvider'

export const site: ContainerModuleLoader = (bind) => {
	bind(WixCodeSdkHandlersProviderSym, PlatformEnvDataProviderSymbol).to(ClientSdkHandlersProvider)
}

export const editor = site

export { config } from './configs'
